<template>
  <div class="awards-by-day-modal">
    <div class="modal-card">
      <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      <header class="modal-card-head">
        <p v-if="!isSeeingPrizes" class="modal-card-title">
          Premiações - {{ date | date }}
        </p>
        <p v-else class="modal-card-title">
          Prêmios - Premiação #{{ (currentAward.numero || '').toUpperCase() }}
        </p>
      </header>
      <section v-show="!isSeeingPrizes" class="modal-card-body awards">
        <b-table :data="awards">
          <template slot-scope="props">
            <b-table-column label="#">{{
              (props.row.numero || '').toUpperCase()
            }}</b-table-column>
            <b-table-column label="Data Emissão">{{
              props.row.data_emissao | date
            }}</b-table-column>
            <b-table-column label="Data Pagamento">{{
              props.row.data_pagamento | date
            }}</b-table-column>
            <b-table-column label="Taxa">{{
              props.row.taxa | currency
            }}</b-table-column>
            <b-table-column label="Valor Total">{{
              props.row.valor_total | currency
            }}</b-table-column>
            <b-table-column label="Status">{{
              props.row.status | titleCase
            }}</b-table-column>
            <b-table-column label="Opções">
              <button
                @click="loadPrizes(props.row)"
                tag="button"
                type="button"
                v-app-button.icon-only
                title="Visualizar"
                v-tooltip.bottom="'Visualizar Prêmios'"
              >
                <b-icon size="is-small" icon="magnify"></b-icon>
              </button>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nenhum registro encontrado.</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>
      <section v-show="isSeeingPrizes" class="modal-card-body prizes">
        <button @click="goBack()" v-app-button.icon-left.clear>
          <b-icon size="is-small" icon="arrow-left" />Voltar
        </button>

        <div class="table-top">
          <app-input
            @input="onInput()"
            v-model="filter"
            placeholder="Pesquisar loja"
          ></app-input>

          <div class="total-prizes">
            <h2>{{ currentAward.valor_total | currency }}</h2>
            <p>Total Resgates</p>
          </div>
        </div>
        <b-table :data="prizes">
          <template slot-scope="props">
            <b-table-column label="Revenda">
              {{ props.row.loja || '-' }}
            </b-table-column>
            <b-table-column label="CPF">
              {{ props.row.cpf | VMask('###.###.###-##') }}
            </b-table-column>
            <b-table-column label="Proxy">{{ props.row.proxy }}</b-table-column>
            <b-table-column label="Valor">
              {{ props.row.valor | currency }}
            </b-table-column>
            <b-table-column label="Status">
              {{ props.row.status }}
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nenhum registro encontrado.</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <button type="button" v-app-button.clear @click="$parent.close()">
          Fechar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import DashboardService from '@/services/dashboard.service';
import debounce from 'lodash/debounce';

export default {
  name: 'awards-by-day-modal',
  props: ['date', 'awards'],
  filters: {
    titleCase(value) {
      return `${value[0].toUpperCase()}${value.slice(1)}`;
    },
  },
  data: () => {
    return {
      isLoading: false,
      isSeeingPrizes: false,
      currentAward: {},
      prizes: [],
      filter: '',
    };
  },
  methods: {
    loadPrizes(award) {
      this.currentAward = { ...award };
      this.isLoading = true;

      DashboardService.getPrizesByAward(award.id_premiacao, this.filter)
        .then(({ data }) => {
          this.prizes = data;
          this.isSeeingPrizes = true;
        })
        .finally(() => (this.isLoading = false));
    },
    goBack() {
      this.isSeeingPrizes = false;
      this.currentAward = '';
      this.prizes = [];
    },
    onInput: debounce(function () {
      this.loadPrizes(this.currentAward);
    }, 400),
  },
};
</script>

<style lang="scss" scoped>
.modal-card {
  width: 100%;

  &-head {
    background: var(--color-primary-light);
  }

  &-title {
    color: #fff;
  }

  &-foot {
    display: flex;
    align-content: center;
    justify-content: flex-end;
  }
}

.table-top {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .total-prizes {
    h2,
    p {
      text-align: right;
    }

    h2 {
      font-weight: 600;
      font-size: 1.4rem;
      color: var(--color-primary);
    }

    p {
      font-size: 0.9rem;
      color: var(--text-color-light);
    }
  }
}
</style>
